import { type FunctionComponent } from 'react'
import { format, roundToNearestMinutes } from 'date-fns'
import { type InboxThreadEventEventableSmsMessage } from '@/state/entities/inbox/inbox.types'
import { TimeFormats } from '@/common/datepicker/utilities/formats'
import { ThreadPopover } from './common'
import { MessageRow, emailBodyClasses } from './message-row'

const ThreadSmsBox: FunctionComponent<{
  threadId: string
  event: InboxThreadEventEventableSmsMessage
}> = ({ event }) => {
  return (
    <MessageRow
      direction="incoming"
      name="SMS"
      meta="Incoming SMS"
      time={format(
        roundToNearestMinutes(event.created_at, { nearestTo: 10 }),
        TimeFormats.FourHourApple
      )}
      info={<ThreadPopover event={event} />}
    >
      <div
        className={emailBodyClasses}
        dangerouslySetInnerHTML={{ __html: event.message }}
      />
    </MessageRow>
  )
}

export default ThreadSmsBox
